let dateTimeRegEx = /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}(:\d{1,2}(\.\d+)?)?(Z)?$/;

export default function stringToDate(input: any): any {
  // Ignore things that aren't objects.
  if (typeof input !== 'object') {
    return input;
  }

  for (var key in input) {
    if (!input.hasOwnProperty(key)) {
      continue;
    }

    var value = input[key];
    var match;

    if (typeof value === 'string' && (match = value.match(dateTimeRegEx))) {
      var dateValue = match[0];
      if (!match[3]) {
        dateValue = dateValue + 'Z';
      }
      var milliseconds = Date.parse(dateValue);
      if (!isNaN(milliseconds)) {
        input[key] = new Date(milliseconds);
      }
    } else if (typeof value === 'object') {
      // Recurse into object
      stringToDate(value);
    }
  }
  return input;
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--5!./src/app/services/utility/stringToDate.ts